import LightboxWidget from './LightboxWidget';
export const initLightbox = () => {
    window.Lightbox = new LightboxWidget({});
};
document.querySelectorAll('.js-popup-gallery').forEach((container, index) => {
    container.querySelectorAll('a').forEach((a) => {
        a.setAttribute('data-lightbox', `gallery-${index}`);
    });
});
initLightbox();
